// The upload transport (010 T069, FR-013): an article image goes straight to the storage address
// createStoryImageUpload returns (not through the API), with the method and headers it names. The fetch used for it
// is provided here so tests can observe it; in the browser it is the window's fetch, without credentials (the
// address is signed). Hosting must allow that address in connect-src (research A-24).
import { createContext, useContext } from 'react';

/** The fetch that sends uploads to the storage address. */
export const UploadContext = createContext<typeof fetch>((...args) => fetch(...args));

/**
 * The upload fetch.
 * @returns the fetch from the nearest provider
 */
export function useUploadFetch(): typeof fetch {
  return useContext(UploadContext);
}
